export default __webpack_public_path__ + "static/Raffles Girls School-0408b335e333f55807749c1ecfdab11e.png";